import gql from 'graphql-tag';

export default gql`
  mutation deleteTeam($id: ID!) {
    deleteTeam(id: $id) {
      __typename
      id
      name
      icon
      description
      teamLeadId
      teamLead {
        __typename
        cognitoId
        username
        avatarUrl
      }
    }
  }
`;
